import {
    Box,
    Button,
    Grid,
    InputAdornment,
    makeStyles,
    TextField,
    Typography,
} from "@material-ui/core";
import {
    ToggleButton,
    ToggleButtonGroup
} from "@material-ui/lab";
import {KeyboardDatePicker} from "@material-ui/pickers";
import React from "react";
import {Controller, useForm} from "react-hook-form";
import {toast} from "react-toastify";
import styled from "styled-components";
import apiHelper from "../../../util/ApiHelper";
import {checkExtIsImg, modal} from "../../../util";
import {useLoading} from "../../../util/LoadingProvider";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Chip from "@material-ui/core/Chip";
import { format, parse } from "date-fns";

const useStyles = makeStyles((theme) => ({
    innerBox: {
        background: "#ffffff",
        marginBottom: theme.spacing(4),
        "& *": {
            fontSize: "13px",
            lineHeight: "15px",
        },
    },
    sectionBox: {
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3),
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
    },
    sectionTitle: {
        fontWeight: "300",
        fontSize: "13px",
        lineHeight: "15px",
        color: "#333333",
    },
    itemTitle: {
        fontWeight: "bold",
        fontSize: "12px",
        lineHeight: "14px",
        color: "#333333",
    },
    itemValue: {
        fontWeight: "normal",
        fontSize: "14px",
        lineHeight: "16px",
        color: "#333333",
    },
    input: {
        width: "100%",
        "& button": {
            fontSize: "13px",
            lineHeight: "15px",
            width: "25%",
        },
    },
    buttonGroup: {
        textAlign: "right",
        marginTop: "-20px",
        "& button": {
            color: "#306F9D",
            fontSize: "13px",
            textTransform: "inherit",
        },
    },
    customLabel: {
        "& label": {
            color: "black",
            fontWeight: 700,
            fontSize: "16px",
        },
    },
    select: {
        "& .MuiSelect-icon": {
            top: "calc(50% - 6px)"
        }
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        maxWidth: 300,
    },
    chips: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    chip: {
        margin: 2,
    },
}));

const filmmakerOptions = [
    'Director',
    'Scriptwriter',
    'Cast',
    'Producer',
    'Distributor'
];

const defaultFormValues = {
    certifyingLetter: "",
    city: "",
    contactAddress: "",
    contactTelephone: "",
    country: "",
    durationFrom: null,
    durationTo: null,
    email: "",
    fax: "",
    passcode: "",
    films: {
        "0": "",
        "1": "",
        "2": "",
        "3": "",
        "4": "",
        "5": "",
    }, // used when professionalCategory is 0
    fmPosition: "",
    position: "", // used when professionalCategory is 1
    givenName: "",
    nameOfCompany: "", // used when professionalCategory is 0
    nameOfFilm: "", // used when professionalCategory is 1
    othersSpecify: "", // used when professionalCategory is 2
    paymentUrl: "",
    paymentRemark: "",
    paymentStatus: 0,
    photo: "",
    professionalCategory: "",
    referenceNum: "",
    status: "",
    surname: "",
    telephone: "",
    title: "",
    workingPass: "",
};

const A = styled.a`
  color: #306F9D;
  text-decoration: none;
`;

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

function GuestAccreditationDetailPage({
                                          disabled,
                                          ...props
                                      }) {
    const classes = useStyles();
    const {match} = props;
    const {id} = match.params;
    const [filmmaker, setFilmmaker] = React.useState([]);
    const [defaultValue, setDefaultValue] = React.useState(defaultFormValues);
    const [emailType, setEmailType] = React.useState('');
    const {setLoading} = useLoading();

    const {
        control,
        handleSubmit,
        watch,
        setValue,
        reset,
        getValues,
        trigger,
        formState: { errors }
    } = useForm({
        defaultValues: React.useMemo(() => defaultValue, [defaultValue]),
    });

    const professionalCategory = watch('professionalCategory');
    const paymentStatus = watch('paymentStatus');
    const passcode = watch('passcode');
    const status = watch('status'); 

    const handleChangeFilmmaker = (event) => {
        setFilmmaker(event.target.value);
    };

    // add https to url for email content
    const addHttps = (url) => {
        if (!url) return "";
        if (!url.startsWith("http")) {
            return `https://${url}`;
        }
        return url;
    }

    const onSubmit = async (value) => {
        setLoading(true);
        console.log("enter");
        try {
            const processedFilmmaker = filmmaker.join(',');
            const processedPaymentUrl = addHttps(value.paymentUrl);
            const processedValue = JSON.stringify({
                ...value,
                filmmaker: processedFilmmaker,
                films: JSON.stringify(value.films),
                paymentUrl: processedPaymentUrl,
            });
            console.log('submitted', processedValue);
            const result = await apiHelper.hkiff.updateGuestById(id, processedValue);
            console.log('result', result);
            if (result.status === 200) {
                toast.dark("Guest accreditation is updated.");
                getGuestById();
            }
        } catch (e) {
            console.log(e);
        }
        setLoading(false);
    };

    const sendGuestEmail = React.useCallback(async (target_email_name = '') => {
        setLoading(true);
        try {
            const values = getValues();
            await onSubmit(values);
            let type = '';
            switch (emailType) {
                default:
                case 0:
                    break;
                case 1:
                    type = 'g_a_confirm_self_pick_up';
                    break;
                case 2:
                    type = 'g_a_confirm_not_self_pick_up';
                    break;
                case 3:
                    type = 'g_a_reject';
                    break;
            }
            if (target_email_name.length > 0) {
                type = target_email_name;
            }
            await apiHelper.hkiff.sendGuestEmailById(id, type);
            toast.dark("Your email is sent.");
        } catch (e) {
            console.log(e);
        }
        setLoading(false);
    },[emailType, id])

    const sendPasscodeEmail = async () => {
        // Validate all form fields before proceeding to prevent saving invalid data
        const isFormValid = await trigger();
        if (!isFormValid) {
            toast.error("Please fix all validation errors before sending the email.");
            return;
        }

        setLoading(true);
        try {
            // First update the form data
            const currentValues = getValues();
            await onSubmit(currentValues);
            
            // Then send the passcode email using the Guest Accreditation unified endpoint
            await apiHelper.hkiff.sendGuestEmailById(id, 'g_passcode');
            toast.dark("Passcode email is sent.");
        } catch (e) {
            console.log(e);
        }
        setLoading(false);
    }

    const handleFileUpload = (field, e) => {
        apiHelper.hkiff
            .uploadHKIFFFile(e.target.files[0], "GUEST_ACCREDITATION")
            .then((response) => {
                console.log(response);
                setValue(field, response.data.url);
            })
            .catch((error) => console.log(error));
    };

    const certifyingLetter = watch("certifyingLetter");
    const workingPass = watch("workingPass");
    const photo = watch("photo");

    const getGuestById = React.useCallback(async () => {
        try {
            setLoading(true);
            const result = await apiHelper.hkiff.getGuestById(id);
            console.log(result);
            let processedFilms;
            try {
                processedFilms = JSON.parse(result.data.films);
            } catch (e) {
                console.log(e);
            }
            const {filmmaker, ...resultData} = result.data;
            const processedValue = {
                ...resultData,
                films: processedFilms,
            };
            const processedFilmmaker = filmmaker ? filmmaker.split(',') : [];
            setFilmmaker(processedFilmmaker);
            let type = '';
            switch (result.data.status) {
                default:
                case 0:
                    break;
                case 1:
                    type = 'g_a_confirm_self_pick_up';
                    break;
                case 2:
                    type = 'g_a_confirm_not_self_pick_up';
                    break;
                case 3:
                    type = 'g_a_reject';
                    break;
            }
            setEmailType(type);
            setDefaultValue(processedValue);
            reset(processedValue);
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    }, [setLoading]);

    React.useEffect(() => {
        getGuestById();
    }, [getGuestById]);

    console.log(defaultValue);

    return (
        <Box>
            <Typography variant="h4" gutterBottom>
                Accreditation &gt; Update Guest
                Accreditation
            </Typography>
            <form onSubmit={handleSubmit(onSubmit)}>
                <fieldset disabled={disabled}
                          className="fieldset">
                    <Box className={classes.innerBox}>
                        <Box className={classes.sectionBox}>
                            <Grid container xs={12}
                                  direction="row"
                                  spacing={3}>
                                <Grid item xs={12}>
                                    <strong>Name
                                        Title</strong>
                                </Grid>
                            </Grid>
                            <Grid container xs={12}
                                  direction="row"
                                  spacing={3}>
                                <Grid container item
                                      direction="column"
                                      spacing={1} xs={6}>
                                    <Grid item>
                                        <Controller
                                            control={control}
                                            name="title"
                                            render={({
                                                         field: {
                                                             value,
                                                             onChange,
                                                             ...rest
                                                         },
                                                         fieldState,
                                                     }) => (
                                                <ToggleButtonGroup
                                                    {...rest}
                                                    value={value}
                                                    onChange={(event, newFormats) => {
                                                        if (newFormats !== null) {
                                                            onChange(newFormats);
                                                        }
                                                    }}
                                                    exclusive
                                                    aria-label="Name Title"
                                                    className={classes.input}
                                                >
                                                    <ToggleButton
                                                        value={0}
                                                        aria-label="Mr">
                                                        Mr
                                                    </ToggleButton>
                                                    <ToggleButton
                                                        value={2}
                                                        aria-label="Ms">
                                                        Ms
                                                    </ToggleButton>
                                                    <ToggleButton
                                                        value={3}
                                                        aria-label="Mrs">
                                                        Mrs
                                                    </ToggleButton>
                                                    <ToggleButton
                                                        value={4}
                                                        aria-label="Dr">
                                                        Dr
                                                    </ToggleButton>
                                                    <ToggleButton
                                                        value={5}
                                                        aria-label="Miss">
                                                        Miss
                                                    </ToggleButton>
                                                </ToggleButtonGroup>
                                            )}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Box>
                        <Box className={classes.sectionBox}>
                            <Grid container item xs={12}
                                  spacing={3}>
                                <Grid item xs={6}>
                                    <Controller
                                        name="surname"
                                        control={control}
                                        render={({
                                                     field,
                                                     fieldState: {error}
                                                 }) => (
                                            <TextField
                                                label="Surname"
                                                variant="outlined"
                                                margin="dense"
                                                className={classes.textInput}
                                                fullWidth
                                                {...field}
                                                error={!!error}
                                                helperText={error ? error.message : ""}
                                            />
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <Controller
                                        name="givenName"
                                        control={control}
                                        render={({
                                                     field,
                                                     fieldState: {error}
                                                 }) => (
                                            <TextField
                                                label="Given Name"
                                                variant="outlined"
                                                margin="dense"
                                                className={classes.textInput}
                                                fullWidth
                                                {...field}
                                                error={!!error}
                                                helperText={error ? error.message : ""}
                                            />
                                        )}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container item xs={12}
                                  spacing={3}>
                                <Grid item xs={6}>
                                    <Controller
                                        name="country"
                                        control={control}
                                        render={({
                                                     field,
                                                     fieldState: {error}
                                                 }) => (
                                            <TextField
                                                label="Country"
                                                variant="outlined"
                                                margin="dense"
                                                className={classes.textInput}
                                                fullWidth
                                                {...field}
                                                error={!!error}
                                                helperText={error ? error.message : ""}
                                            />
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <Controller
                                        name="city"
                                        control={control}
                                        render={({
                                                     field,
                                                     fieldState: {error}
                                                 }) => (
                                            <TextField
                                                label="City"
                                                variant="outlined"
                                                margin="dense"
                                                className={classes.textInput}
                                                fullWidth
                                                {...field}
                                                error={!!error}
                                                helperText={error ? error.message : ""}
                                            />
                                        )}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container item xs={12}
                                  spacing={3}>
                                <Grid item xs={6}>
                                    <Controller
                                        name="telephone"
                                        control={control}
                                        render={({
                                                     field,
                                                     fieldState: {error}
                                                 }) => (
                                            <TextField
                                                label="Telephone"
                                                variant="outlined"
                                                margin="dense"
                                                className={classes.textInput}
                                                fullWidth
                                                {...field}
                                                error={!!error}
                                                helperText={error ? error.message : ""}
                                            />
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <Controller
                                        name="fax"
                                        control={control}
                                        render={({
                                                     field,
                                                     fieldState: {error}
                                                 }) => (
                                            <TextField
                                                label="Fax"
                                                variant="outlined"
                                                margin="dense"
                                                className={classes.textInput}
                                                fullWidth
                                                {...field}
                                                error={!!error}
                                                helperText={error ? error.message : ""}
                                            />
                                        )}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container item xs={12}
                                  spacing={3}>
                                <Grid item xs={6}>
                                    <Controller
                                        name="email"
                                        control={control}
                                        render={({
                                                     field,
                                                     fieldState: {error}
                                                 }) => (
                                            <TextField
                                                label="Email"
                                                variant="outlined"
                                                margin="dense"
                                                className={classes.textInput}
                                                fullWidth
                                                {...field}
                                                error={!!error}
                                                helperText={error ? error.message : ""}
                                            />
                                        )}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container item xs={12}
                                  spacing={3}>
                                <Grid item xs={6}>
                                    <Controller
                                        name="passcode"
                                        control={control}
                                        rules={{
                                            validate: {
                                                exactLength: value => !value || value.length === 6 || 'Passcode must be exactly 6 characters',
                                                alphanumeric: value => !value || /^[A-Za-z0-9]{6}$/.test(value) || 'Passcode must contain only letters and numbers'
                                            }
                                        }}
                                        render={({
                                                     field,
                                                     fieldState: {error}
                                                 }) => (
                                            <TextField
                                                label="Passcode"
                                                variant="outlined"
                                                margin="dense"
                                                className={classes.textInput}
                                                fullWidth
                                                {...field}
                                                error={!!error}
                                                helperText={error ? error.message : ""}
                                                inputProps={{
                                                    maxLength: 6,
                                                }}
                                            />
                                        )}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container item xs={12}
                                  spacing={3}>
                                <Grid item xs={6}>
                                    <FormControl fullWidth
                                                 margin="dense"
                                                 variant="outlined">
                                        <InputLabel
                                            id="demo-simple-select-outlined-label">
                                            Professional
                                            Category
                                        </InputLabel>
                                        <Controller
                                            name="professionalCategory"
                                            control={control}
                                            render={({
                                                         field,
                                                         fieldState: {error}
                                                     }) => (
                                                <Select
                                                    labelId="demo-simple-select-outlined-label"
                                                    id="demo-simple-select-outlined"
                                                    value={0}
                                                    label="Professional Category"
                                                    className={classes.select}
                                                    {...field}
                                                >
                                                    <MenuItem
                                                        value={"0"}>
                                                        <em>Director/Scriptwriter/Cast/Producer/Distributor</em>
                                                    </MenuItem>
                                                    <MenuItem
                                                        value={"1"}>
                                                        <em>Festival
                                                            Delegate</em>
                                                    </MenuItem>
                                                    <MenuItem
                                                        value={"2"}>
                                                        <em>Others</em>
                                                    </MenuItem>
                                                </Select>
                                            )}
                                        />
                                    </FormControl>
                                </Grid>
                                {
                                    professionalCategory === "0" ? (
                                            <Grid item xs={6}>
                                                {/*introduced structural changes to trigger value differentiation*/}
                                                <div/>
                                                <Controller
                                                    name="nameOfCompany"
                                                    control={control}
                                                    rules={{
                                                        validate: {
                                                            required: value => {
                                                                if (!value && professionalCategory === "0") return 'Required';
                                                                return true;
                                                            }
                                                        }
                                                    }}
                                                    render={({
                                                                 field,
                                                                 fieldState: {error}
                                                             }) => (
                                                        <TextField
                                                            label="Name of Company"
                                                            variant="outlined"
                                                            margin="dense"
                                                            className={classes.textInput}
                                                            fullWidth
                                                            {...field}
                                                            error={!!error}
                                                            helperText={error ? error.message : ""}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                        )
                                        :
                                        professionalCategory === "1" ? (

                                                <Grid item
                                                      xs={6}>
                                                    {/*introduced structural changes to trigger value differentiation*/}
                                                    <span/>
                                                    <Controller
                                                        name="position"
                                                        control={control}
                                                        rules={{
                                                            validate: {
                                                                required: value => {
                                                                    if (!value && professionalCategory === "1") return 'Required';
                                                                    return true;
                                                                }
                                                            }
                                                        }}
                                                        render={({
                                                                     field,
                                                                     fieldState: {error}
                                                                 }) => (
                                                            <TextField
                                                                label="Position"
                                                                variant="outlined"
                                                                margin="dense"
                                                                className={classes.textInput}
                                                                fullWidth
                                                                {...field}
                                                                error={!!error}
                                                                helperText={error ? error.message : ""}
                                                            />
                                                        )}
                                                    />
                                                </Grid>
                                            )
                                            :
                                            (
                                                <Grid item
                                                      xs={6}>
                                                    <Controller
                                                        name="othersSpecify"
                                                        control={control}
                                                        rules={{
                                                            validate: {
                                                                required: value => {
                                                                    if (!value && professionalCategory === "2") return 'Required';
                                                                    return true;
                                                                }
                                                            }
                                                        }}
                                                        render={({
                                                                     field,
                                                                     fieldState: {error}
                                                                 }) => (
                                                            <TextField
                                                                label="Others Specify"
                                                                variant="outlined"
                                                                margin="dense"
                                                                className={classes.textInput}
                                                                fullWidth
                                                                {...field}
                                                                error={!!error}
                                                                helperText={error ? error.message : ""}
                                                            />
                                                        )}
                                                    />
                                                </Grid>
                                            )
                                }
                            </Grid>
                            {/* for professionalCategory = 0 --- films field */}
                            {
                                professionalCategory === "0" && (
                                    <>
                                        <Grid container
                                              item
                                              xs={12}
                                              spacing={3}>
                                            <Grid
                                                item
                                                xs={6}>
                                                <FormControl
                                                    fullWidth
                                                    margin="dense"
                                                    variant="outlined">
                                                    <InputLabel
                                                        id="demo-mutiple-chip-label">Film
                                                        Maker
                                                        Role</InputLabel>
                                                    <Select
                                                        labelId="demo-mutiple-chip-label"
                                                        id="demo-mutiple-chip"
                                                        multiple
                                                        value={filmmaker}
                                                        onChange={handleChangeFilmmaker}
                                                        label="Film Maker Role"
                                                        className={classes.select}
                                                        renderValue={(selected) => (
                                                            <div
                                                                className={classes.chips}>
                                                                {selected.map((value) => (
                                                                    <Chip
                                                                        key={value}
                                                                        label={value}
                                                                        className={classes.chip}/>
                                                                ))}
                                                            </div>
                                                        )}
                                                        MenuProps={MenuProps}
                                                    >
                                                        {filmmakerOptions.map((filmmakerOption) => (
                                                            <MenuItem
                                                                key={filmmakerOption}
                                                                value={filmmakerOption}>
                                                                {filmmakerOption}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                        {Array(3).fill().map((_, i) => {
                                            return (
                                                <Grid container
                                                      item
                                                      xs={12}
                                                      spacing={3}>
                                                    {Array(2).fill().map((_, j) => {
                                                        return (
                                                            <Grid
                                                                item
                                                                xs={6}>
                                                                <Controller
                                                                    name={`films.${i * 2 + j}`}
                                                                    control={control}
                                                                    rules={{
                                                                        validate: {
                                                                            required: value => {
                                                                                if (i * 2 + j === 0 && !value && professionalCategory === "0") return 'Required';
                                                                                return true;
                                                                            }
                                                                        }
                                                                    }}
                                                                    render={({
                                                                                 field,
                                                                                 fieldState: {error}
                                                                             }) => (
                                                                        <TextField
                                                                            label={`Film ${i * 2 + j + 1}`}
                                                                            variant="outlined"
                                                                            margin="dense"
                                                                            className={classes.textInput}
                                                                            fullWidth
                                                                            {...field}
                                                                            error={!!error}
                                                                            helperText={error ? error.message : ""}
                                                                        />
                                                                    )}
                                                                />
                                                            </Grid>
                                                        )
                                                    })
                                                    }

                                                </Grid>
                                            )
                                        })}

                                    </>)
                            }
                            {/* for professionalCategory = 1 --- nameOfFilm field */}
                            {
                                professionalCategory === "1" && (
                                    <Grid container item xs={12}
                                          spacing={3}>
                                        <Grid item xs={6}>
                                            <Controller
                                                name="nameOfFilm"
                                                control={control}
                                                rules={{
                                                    validate: {
                                                        required: value => {
                                                            if (!value && professionalCategory === "1") return 'Required';
                                                            return true;
                                                        }
                                                    }
                                                }}
                                                render={({
                                                             field,
                                                             fieldState: {error}
                                                         }) => (
                                                    <TextField
                                                        label="Name of Film"
                                                        variant="outlined"
                                                        margin="dense"
                                                        className={classes.textInput}
                                                        fullWidth
                                                        {...field}
                                                        error={!!error}
                                                        helperText={error ? error.message : ""}
                                                    />
                                                )}
                                            />
                                        </Grid>
                                    </Grid>
                                )
                            }
                        </Box>
                    </Box>

                    <Box className={classes.innerBox}>
                        <Box className={classes.sectionBox}>
                            <Grid container xs={12}
                                  direction="row"
                                  spacing={3}>
                                <Grid item xs={12}>
                                    <strong>Reference</strong>
                                </Grid>
                            </Grid>
                            <Grid container xs={12}
                                  direction="row"
                                  spacing={3}>
                                <Grid container item
                                      direction="column"
                                      spacing={1} xs={6}>
                                    <Grid container item
                                          xs={12}>
                                        <TextField
                                            htmlFor={`raised-button-file-certifying-letter`}
                                            label="Upload Certifying Letter"
                                            className={classes.fileInput}
                                            value=""
                                            variant="outlined"
                                            placeholder="Upload Certifying Letter"
                                            fullWidth
                                            InputProps={{
                                                classes: {
                                                    input: classes["&::placeholder"],
                                                },
                                                endAdornment: (
                                                    <Controller
                                                        control={control}
                                                        name="certifyingLetter"
                                                        render={({field}) => {
                                                            return (
                                                                <InputAdornment
                                                                    position="end">
                                                                    <input
                                                                        style={{display: "none"}}
                                                                        id={`raised-button-file-certifying-letter`}
                                                                        type="file"
                                                                        onChange={(e) => {
                                                                            handleFileUpload("certifyingLetter", e);
                                                                        }}
                                                                    />
                                                                    <Button
                                                                        htmlFor={`raised-button-file-certifying-letter`}
                                                                        variant="outlined"
                                                                        component="label"
                                                                        size="small"
                                                                    >
                                                                        Choose
                                                                    </Button>
                                                                </InputAdornment>
                                                            );
                                                        }}
                                                    />
                                                ),
                                            }}
                                        />

                                        {certifyingLetter && (
                                            <p>
                                                {checkExtIsImg(certifyingLetter) && (
                                                    <>
                                                        <img
                                                            src={certifyingLetter}
                                                            style={{
                                                                maxHeight: "30px",
                                                                maxWidth: "30px"
                                                            }}
                                                            onClick={() => window.open(certifyingLetter, '_blank').focus()}
                                                            alt=""
                                                        />
                                                        &nbsp;
                                                    </>
                                                )
                                                }
                                                <A href={certifyingLetter}
                                                   target="_blank"><small>{certifyingLetter.split("/").pop()}</small></A>
                                                <small
                                                    style={{
                                                        marginLeft: "20px",
                                                        textDecoration: "underline",
                                                        color: "#962013",
                                                        cursor: "pointer",
                                                    }}
                                                    onClick={async () => {
                                                        const decision = await modal.fire({
                                                            title: "Delete File",
                                                            text: "Are you sure to delete this file?",
                                                            showCancelButton: true,
                                                            confirmButtonText: `Delete`,
                                                        });
                                                        if (decision.isConfirmed) {
                                                            setValue("certifyingLetter", "");
                                                        }
                                                    }}
                                                >
                                                    Delete
                                                </small>
                                            </p>
                                        )}
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid container xs={12}
                                  direction="row"
                                  spacing={3}>
                                <Grid container item
                                      direction="column"
                                      spacing={1} xs={6}>
                                    <Grid container item
                                          xs={12}>
                                        <TextField
                                            htmlFor={`raised-button-file-working-pass`}
                                            label="Upload Working Pass"
                                            className={classes.fileInput}
                                            value=""
                                            variant="outlined"
                                            placeholder="Upload Working Pass"
                                            fullWidth
                                            InputProps={{
                                                classes: {
                                                    input: classes["&::placeholder"],
                                                },
                                                endAdornment: (
                                                    <Controller
                                                        control={control}
                                                        name="workingPass"
                                                        render={({field}) => {
                                                            return (
                                                                <InputAdornment
                                                                    position="end">
                                                                    <input
                                                                        style={{display: "none"}}
                                                                        id={`raised-button-file-working-pass`}
                                                                        type="file"
                                                                        onChange={(e) => {
                                                                            handleFileUpload("workingPass", e);
                                                                        }}
                                                                    />
                                                                    <Button
                                                                        htmlFor={`raised-button-file-working-pass`}
                                                                        variant="outlined"
                                                                        component="label"
                                                                        size="small"
                                                                    >
                                                                        Choose
                                                                    </Button>
                                                                </InputAdornment>
                                                            );
                                                        }}
                                                    />
                                                ),
                                            }}
                                        />

                                        {workingPass && (
                                            <p>
                                                {checkExtIsImg(workingPass) && (
                                                    <>
                                                        <img
                                                            src={workingPass}
                                                            style={{
                                                                maxHeight: "30px",
                                                                maxWidth: "30px"
                                                            }}
                                                            onClick={() => window.open(workingPass, '_blank').focus()}
                                                            alt=""
                                                        />
                                                        &nbsp;
                                                    </>
                                                )
                                                }
                                                <A href={workingPass}
                                                   target="_blank"><small>{workingPass.split("/").pop()}</small></A>
                                                <small
                                                    style={{
                                                        marginLeft: "20px",
                                                        textDecoration: "underline",
                                                        color: "#962013",
                                                        cursor: "pointer",
                                                    }}
                                                    onClick={async () => {
                                                        const decision = await modal.fire({
                                                            title: "Delete File",
                                                            text: "Are you sure to delete this file?",
                                                            showCancelButton: true,
                                                            confirmButtonText: `Delete`,
                                                        });
                                                        if (decision.isConfirmed) {
                                                            setValue("workingPass", "");
                                                        }
                                                    }}
                                                >
                                                    Delete
                                                </small>
                                            </p>
                                        )}
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid container xs={12}
                                  direction="row"
                                  spacing={3}>
                                <Grid container item
                                      direction="column"
                                      spacing={1} xs={6}>
                                    <Grid container item
                                          xs={12}>
                                        <TextField
                                            htmlFor={`raised-button-file-personal-photo`}
                                            label="Upload Personal Photo"
                                            className={classes.fileInput}
                                            value=""
                                            variant="outlined"
                                            placeholder="Upload Personal Photo"
                                            fullWidth
                                            InputProps={{
                                                classes: {
                                                    input: classes["&::placeholder"],
                                                },
                                                endAdornment: (
                                                    <Controller
                                                        control={control}
                                                        name="photo"
                                                        render={({field}) => {
                                                            return (
                                                                <InputAdornment
                                                                    position="end">
                                                                    <input
                                                                        style={{display: "none"}}
                                                                        id={`raised-button-file-personal-photo`}
                                                                        type="file"
                                                                        onChange={(e) => {
                                                                            handleFileUpload("photo", e);
                                                                        }}
                                                                    />
                                                                    <Button
                                                                        htmlFor={`raised-button-file-personal-photo`}
                                                                        variant="outlined"
                                                                        component="label"
                                                                        size="small"
                                                                    >
                                                                        Choose
                                                                    </Button>
                                                                </InputAdornment>
                                                            );
                                                        }}
                                                    />
                                                ),
                                            }}
                                        />

                                        {photo && (
                                            <p>
                                                {checkExtIsImg(photo) && (
                                                    <>
                                                        <img
                                                            src={photo}
                                                            style={{
                                                                maxHeight: "30px",
                                                                maxWidth: "30px"
                                                            }}
                                                            onClick={() => window.open(photo, '_blank').focus()}
                                                            alt=""
                                                        />
                                                        &nbsp;
                                                    </>
                                                )}
                                                <A href={photo}
                                                   target="_blank"><small>{photo.split("/").pop()}</small></A>
                                                <small
                                                    style={{
                                                        marginLeft: "20px",
                                                        textDecoration: "underline",
                                                        color: "#962013",
                                                        cursor: "pointer",
                                                    }}
                                                    onClick={async () => {
                                                        const decision = await modal.fire({
                                                            title: "Delete Image",
                                                            text: "Are you sure to delete this file?",
                                                            showCancelButton: true,
                                                            confirmButtonText: `Delete`,
                                                        });
                                                        if (decision.isConfirmed) {
                                                            setValue("photo", "");
                                                        }
                                                    }}
                                                >
                                                    Delete
                                                </small>
                                            </p>
                                        )}
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>
                    <Box className={classes.innerBox}>
                        <Box className={classes.sectionBox}>
                            <Grid container xs={12}
                                  direction="row"
                                  spacing={3}>
                                <Grid item xs={12}>
                                    <strong>Duration</strong>
                                </Grid>
                                <Grid container item xs={6}
                                      direction="row">
                                    <Grid item xs={6}>
                                        <Controller
                                            name={`durationFrom`}
                                            control={control}
                                            render={({
                                                         field,
                                                         fieldState: {error}
                                                     }) => (
                                                <KeyboardDatePicker
                                                    fullWidth
                                                    variant="inline"
                                                    format="dd/MM/yyyy"
                                                    margin="dense"
                                                    id="date-picker-inline"
                                                    label="From"
                                                    {...field}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    classes={{root: classes.customLabel}}
                                                    KeyboardButtonProps={{
                                                        "aria-label": "change date",
                                                    }}
                                                    helperText={""}
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Controller
                                            name={`durationTo`}
                                            control={control}
                                            render={({
                                                         field,
                                                         fieldState: {error}
                                                     }) => (
                                                <KeyboardDatePicker
                                                    fullWidth
                                                    variant="inline"
                                                    format="dd/MM/yyyy"
                                                    margin="dense"
                                                    id="date-picker-inline"
                                                    label="To"
                                                    {...field}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    classes={{root: classes.customLabel}}
                                                    KeyboardButtonProps={{
                                                        "aria-label": "change date",
                                                    }}
                                                    helperText={""}
                                                />
                                            )}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container item xs={12}
                                      spacing={3}>
                                    <Grid item xs={12}>
                                        <Controller
                                            name="contactAddress"
                                            control={control}
                                            render={({
                                                         field,
                                                         fieldState: {error}
                                                     }) => (
                                                <TextField
                                                    label="Contact Address"
                                                    variant="outlined"
                                                    margin="dense"
                                                    className={classes.textInput}
                                                    fullWidth
                                                    {...field}
                                                    error={!!error}
                                                    helperText={error ? error.message : ""}
                                                />
                                            )}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container item xs={12}
                                      spacing={3}>
                                    <Grid item xs={6}>
                                        <Controller
                                            name="contactTelephone"
                                            control={control}
                                            render={({
                                                         field,
                                                         fieldState: {error}
                                                     }) => (
                                                <TextField
                                                    label="Contact Telephone"
                                                    variant="outlined"
                                                    margin="dense"
                                                    className={classes.textInput}
                                                    fullWidth
                                                    {...field}
                                                    error={!!error}
                                                    helperText={error ? error.message : ""}
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Controller
                                            name="contactFax"
                                            control={control}
                                            render={({
                                                         field,
                                                         fieldState: {error}
                                                     }) => (
                                                <TextField
                                                    label="Contact Fax"
                                                    variant="outlined"
                                                    margin="dense"
                                                    className={classes.textInput}
                                                    fullWidth
                                                    {...field}
                                                    error={!!error}
                                                    helperText={error ? error.message : ""}
                                                />
                                            )}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container item xs={12}
                                      direction="row">
                                    <Grid container item
                                          direction="column"
                                          spacing={1}
                                          xs={12}>
                                        <Grid item>
                                            <Typography
                                                className={classes.itemTitle}>
                                                Status
                                            </Typography>
                                        </Grid>
                                        <Grid container item
                                              xs={12}
                                              spacing={3}>
                                            <Grid item
                                                  xs={4}>
                                                <Controller
                                                    control={control}
                                                    name="status"
                                                    render={({
                                                                 field: {
                                                                     value,
                                                                     onChange,
                                                                     ...rest
                                                                 },
                                                                 fieldState: {error},
                                                             }) => (
                                                        <ToggleButtonGroup
                                                            {...rest}
                                                            value={value}
                                                            onChange={(event, newFormats) => {
                                                                if (newFormats !== null) {
                                                                    onChange(newFormats);
                                                                    setEmailType(newFormats)
                                                                }
                                                            }}
                                                            exclusive
                                                            aria-label="Status"
                                                            className={classes.input}
                                                        >
                                                            <ToggleButton
                                                                value={1}
                                                                aria-label="Approved (Self pick-up)"
                                                                style={{width: "33%"}}
                                                            >
                                                                Approved (Self pick-up)
                                                            </ToggleButton>
                                                            <ToggleButton
                                                                value={2}
                                                                aria-label="Approved (Hotel)"
                                                                style={{width: "33%"}}
                                                            >
                                                                Approved (Hotel)
                                                            </ToggleButton>
                                                            <ToggleButton
                                                                value={0}
                                                                aria-label="TBC"
                                                                style={{width: "33%"}}
                                                            >
                                                                TBC
                                                            </ToggleButton>
                                                            <ToggleButton
                                                                value={3}
                                                                aria-label="Reject"
                                                                style={{width: "33%"}}
                                                            >
                                                                Rejected
                                                            </ToggleButton>
                                                        </ToggleButtonGroup>
                                                    )}
                                                />
                                            </Grid>
                                            <Grid item
                                                  xs={2}>
                                                <Button
                                                    type="button"
                                                    variant="outlined"
                                                    disableElevation
                                                    disabled={disabled}
                                                    onClick={() => sendGuestEmail(emailType)}
                                                    style={{
                                                        background: "#306F9D",
                                                        color: "#fff",
                                                        marginRight: "5px",
                                                        padding: "12px 16px",
                                                        borderColor: "#306F9D",
                                                        width: "100%",
                                                        margin: 0,
                                                    }}
                                                >
                                                    Send
                                                    Confirmation
                                                    Email
                                                </Button>
                                            </Grid>
                                             <Grid item
                                                  xs={2}>
                                                <Button
                                                    type="button"
                                                    variant="outlined"
                                                    disableElevation
                                                    // disabled={!passcode || paymentStatus !== 1}
                                                    disabled={!passcode || (status !== 1 && status !== 2)}
                                                    onClick={sendPasscodeEmail}
                                                    style={{
                                                        background: (!passcode || (status !== 1 && status !== 2)) ? "#cccccc" : "#306F9D",
                                                        color: "#fff",
                                                        marginRight: "5px",
                                                        padding: "12px 16px",
                                                        borderColor: (!passcode || (status !== 1 && status !== 2)) ? "#cccccc" : "#306F9D",
                                                        width: "100%",
                                                        margin: 0,
                                                    }}
                                                >
                                                    Send
                                                    Passcode
                                                    Email
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>

                    <Box className={classes.innerBox}>
                        <Box className={classes.sectionBox}>
                            <Grid container xs={12}
                                  direction="row"
                                  spacing={3}>
                                <Grid item xs={12}>
                                    <strong>Payment</strong>
                                </Grid>
                                <Grid container item xs={12}
                                      spacing={3}>
                                    <Grid item xs={12}>
                                        <Controller
                                            name="paymentUrl"
                                            control={control}
                                            render={({
                                                         field,
                                                         fieldState: {error}
                                                     }) => (
                                                <TextField
                                                    label="URL"
                                                    variant="outlined"
                                                    margin="dense"
                                                    className={classes.textInput}
                                                    fullWidth
                                                    {...field}
                                                    error={!!error}
                                                    helperText={error ? error.message : ""}
                                                />
                                            )}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container item xs={12}
                                      spacing={3}>
                                    <Grid item xs={12}>
                                        <Controller
                                            name="paymentRemark"
                                            control={control}
                                            render={({
                                                         field,
                                                         fieldState: {error}
                                                     }) => (
                                                <TextField
                                                    label="Remark"
                                                    variant="outlined"
                                                    margin="dense"
                                                    className={classes.textInput}
                                                    fullWidth
                                                    {...field}
                                                    error={!!error}
                                                    helperText={error ? error.message : ""}
                                                />
                                            )}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container item xs={12}
                                      direction="row">
                                    <Grid container item
                                          direction="column"
                                          spacing={1}
                                          xs={12}>
                                        <Grid item>
                                            <Typography
                                                className={classes.itemTitle}>
                                                Status
                                            </Typography>
                                        </Grid>
                                        <Grid container item
                                              xs={12}
                                              spacing={3}>
                                            <Grid item
                                                  xs={4}>
                                                <Controller
                                                    control={control}
                                                    name="paymentStatus"
                                                    render={({
                                                                 field: {
                                                                     value,
                                                                     onChange,
                                                                     ...rest
                                                                 },
                                                                 fieldState: {error},
                                                             }) => (
                                                        <ToggleButtonGroup
                                                            {...rest}
                                                            value={value}
                                                            onChange={(event, newFormats) => {
                                                                if (newFormats !== null) {
                                                                    onChange(newFormats);
                                                                }
                                                            }}
                                                            exclusive
                                                            aria-label="Status"
                                                            className={classes.input}
                                                        >
                                                            <ToggleButton
                                                                value={0}
                                                                aria-label="Pending"
                                                                style={{width: "50%"}}
                                                            >
                                                                Pending
                                                            </ToggleButton>
                                                            <ToggleButton
                                                                value={1}
                                                                aria-label="Confirmed"
                                                                style={{width: "50%"}}
                                                            >
                                                                Confirmed
                                                            </ToggleButton>
                                                        </ToggleButtonGroup>
                                                    )}
                                                />
                                            </Grid>
                                            <Grid item
                                                  xs={2}>
                                                <Button
                                                    type="button"
                                                    variant="outlined"
                                                    disableElevation
                                                    disabled={disabled}
                                                    onClick={() => sendGuestEmail('g_a_payment')}
                                                    style={{
                                                        background: "#306F9D",
                                                        color: "#fff",
                                                        marginRight: "5px",
                                                        padding: "12px 16px",
                                                        borderColor: "#306F9D",
                                                        width: "100%",
                                                        margin: 0,
                                                    }}
                                                >
                                                    Send
                                                    Payment
                                                    Email
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>
                    {disabled || (
                        <div
                            className={classes.buttonGroup}>
                            <Button
                                type="submit"
                                variant="contained"
                                disableElevation
                                style={{
                                    color: "white",
                                    background: "#306F9D",
                                    padding: "9px 16px",
                                }}
                            >
                                Save Changes
                            </Button>
                        </div>
                    )}
                </fieldset>
            </form>
        </Box>
    );
}

export default GuestAccreditationDetailPage;
